import { BaseInputModel } from "./BaseInputModel"

export abstract class BaseFormPostInputModel extends BaseInputModel {
  abstract get file(): File
}
